<template>
  <v-app>
    <v-main>
      <hero-banner />
      <card-form />
      <app-footer />
    </v-main>
  </v-app>
</template>

<script>
  import HeroBanner from './components/HeroBanner';
  import CardForm from './components/CardForm'
  import Footer from './components/Footer'

  export default {
    name: 'App',

    components: {
      HeroBanner,
      CardForm,
      'AppFooter': Footer
    },

    data: () => ({
      //
    }),
  };
</script>

<style lang="scss">
  @media (min-width: 1904px) {
    .container {
      max-width: 1185px;
      &.container--fluid {
        max-width: 100%;
      }
    }
  }
</style>